<template>
  <create-account-layout
    :current-step="2"
    :title="title"
  >
    <form
      v-if="!isEmailRequiredForLogin"
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <section v-if="!isEmailRequiredForLogin">
        <p class="mb-6 mt-8 text-left text-sm text-dark-gray">
          In order to protect your account, we need to verify your mobile
          number.
        </p>
        <form-field
          id="mobile_phone"
          ref="formField"
          label="Mobile Phone #"
          :value="form.phone_number_without_country_code"
          placeholder="Enter Mobile #"
          :on-input="onInput"
          name="phone_number"
          pattern="number"
          type="tel"
          class="text-dark-blue"
          :error="phoneError"
          :auto-focus="true"
          @country-changed="handleCountryChange"
        />
        <button-main
          class="my-4 mb-4"
          :disabled="isPhoneContinueDisabled"
          type="submit"
          :loading-spinner="isLoading"
          value="Continue"
        />
        <!--         <div class="flex flex-col items-center mt-4">
          <p class="mb-2 text-1md text-body-color">Already have an account?</p>
          <router-link
            to="/login"
            class="text-yellow-500 w-max mx-auto text-1md"
          >Log in</router-link>
        </div> -->
      </section>
    </form>
    <form
      v-else
      novalidate="novalidate"
      @submit.prevent="handleEmailSubmit"
    >
      <section>
        <p class="mb-6 mt-8 text-left text-sm text-dark-gray">
          In order to protect your account, we need to verify your email
          address.
        </p>
        <form-field
          id="email_address"
          label="Email Address"
          :value="email_address"
          placeholder="Enter Email Address"
          :on-input="onEmailInput"
          name="email_address"
          class="text-dark-blue"
          :on-blur="checkEmailAddress"
          :error="email_address_error"
          :auto-focus="true"
        />
        <form-field
          v-if="isAliasRoute"
          id="email_address_verification"
          label="Re-Enter Email Address"
          :value="email_address_verification"
          placeholder="Re-enter Email Address"
          :on-input="onReEnterEmailInput"
          name="email_address_verification"
          class="text-dark-blue"
          :on-blur="checkEmailAddress"
          :error="validateMatchingEmail ? '' : 'Emails do not match'"
          :auto-focus="true"
          @paste.prevent
        />
        <button-main
          class="my-4 mb-4"
          :disabled="
            isIDVOnboardingFlowActive && isAliasRoute
              ? !validateMatchingEmail
              : !!email_address_error
          "
          type="submit"
          :loading-spinner="isLoading"
          value="Continue"
        />
        <!--
        <div class="flex flex-col items-center mt-4">
          <p class="mb-2 text-1md text-body-color">Already have an account?</p>
          <router-link
            to="/login"
            class="text-yellow-500 w-max mx-auto text-1md"
          >Log in</router-link>
        </div> -->
      </section>
    </form>
  </create-account-layout>
</template>

<script>
import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
import FormField from '@/components/FormField.vue';
import ButtonMain from '@/components/Button.vue';
import { isEmail } from '@/common/validators';

// Mixin
import phoneField from '@/mixins/phoneField';
import fullnameAndEmailField from '@/mixins/fullnameAndEmailField';

// Common
import { formatPhone } from '@/common/validators';
import { toastResponse } from '@/common/handleServerResponse';

export default {
  name: 'CreateAccountOrLogin',
  components: {
    CreateAccountLayout,
    FormField,
    ButtonMain,
  },
  mixins: [phoneField, fullnameAndEmailField],
  data() {
    return {
      isLoading: false,
      form: {
        phone_number_without_country_code: '',
      },
      isPhoneContinueDisabled: true,
      email_address_verification: '',
    };
  },
  computed: {
    validateMatchingEmail() {
      return (
        this.validateEmail(this.email_address || '') &&
        this.validateEmail(this.email_address_verification || '') &&
        this.email_address === this.email_address_verification
      );
    },
    // ...mapState({
    //   isEmailRequiredForLogin: (state) =>
    //     state.carriers?.isEmailRequiredForLogin || false,
    // }),
    isIDVOnboardingFlowActive() {
      const status =
        this.$store.state.users.currentUser?.identity_proofing_status;
      if (status === 'skip_identity_proofing') return false;
      if (status === 'require_identity_proofing') return true;
      const featureFlagEnabled = this.$store.getters['users/getFeatureFlag']?.(
        'idv_onboarding_flow'
      )?.enabled;
      return !!featureFlagEnabled;
    },
    isOnboardingEmailVerificationActive() {
      return this.$store.getters['users/getFeatureFlag']?.(
        'onboarding_email_verification'
      )?.['enabled'];
    },
    isEmailRequiredForLogin() {
      const isEmailRequired =
        this.$store.state.carriers?.isEmailRequiredForLogin || false;

      if (this.isIDVOnboardingFlowActive) {
        return isEmailRequired || this.isAliasRoute;
      }

      return isEmailRequired;
    },
    isAliasRoute() {
      return this.$route.matched[0].path === '/sign-up/company-email';
    },
    title() {
      if (!this.isEmailRequiredForLogin) return 'Enter Mobile Number';
      return 'Enter Email Address';
    },
    isUSPhoneContinueDisabled() {
      return (
        this.form?.phone_number_without_country_code?.length !== 12 ||
        !!this.phoneError
      );
    },
  },
  created() {
    console.log(
      'requrested carrier id',
      this.$store.state.carriers.carrierDetails.id
    );
    if (
      this.$store.state.carriers.carrierDetails.id == null &&
      this.$store.state.signUpData?.manualCarrier == null &&
      !this.isIDVOnboardingFlowActive
    ) {
      return this.$router.push({
        name: 'CarrierDetails',
      });
    }
  },
  mounted() {
    if (this.$store.state.signUpData.phone_number) {
      this.assignPhoneFromState();
      // Validate button state after assigning phone from state
      this.$nextTick(() => {
        this.validateButtonState();
      });
    }
  },
  methods: {
    validateEmail(email) {
      return isEmail(email);
    },
    assignPhoneFromState() {
      const phoneWithoutCountryCode =
        this.$store.state.signUpData.phone_number.slice(-10);

      this.form.phone_number_without_country_code = formatPhone(
        phoneWithoutCountryCode
      );
    },
    handleCountryChange() {
      // Reset phone error when country change, if persisted before
      this.phoneError = '';
    },
    validateButtonState() {
      if (
        ['us', 'mx', 'ca'].includes(
          this.$refs?.formField?.elementData?.selectedCountryData?.iso2
        )
      ) {
        this.isPhoneContinueDisabled = this.isUSPhoneContinueDisabled;
      } else {
        this.isPhoneContinueDisabled =
          !this.$refs?.formField?.elementData?.isValidNumber();
      }
    },
    onInput(e) {
      const value = e.target.value;
      if (value.length === 12) this.validatePhone(e);
      this.form.phone_number_without_country_code = formatPhone(value);
      const phone_number_with_country_code =
        this.$refs?.formField?.elementData?.getNumber();
      this.validateButtonState();
      this.$store.commit('updateSignupField', {
        name: 'phone_number',
        value: phone_number_with_country_code,
      });
    },
    onEmailInput(e) {
      this.handleFieldUpdate(e);
    },
    onReEnterEmailInput(e) {
      this.email_address_verification = e.target.value;
    },
    async handleManualCarrierLogin() {
      if (!this.$store.state.signUpData?.manualCarrier) {
        return;
      }
      const { legalName, dbaName, identifierData } =
        this.$store.state.signUpData.manualCarrier;
      this.isLoading = true;
      const res = await this.$store.dispatch('users/postSignUpOrLoginManual', {
        phone_e164: this.$store.state.signUpData.phone_number,
        site: 'highway.com',
        legal_name: legalName,
        dba_name: dbaName || undefined,
        is_type: identifierData.is_type,
        value: identifierData.value,
      });
      this.isLoading = false;
      this.handleManualLoginResponse(res);
    },
    async handleLogin() {
      this.isLoading = true;
      const res = await this.$store.dispatch('users/postSignUpOrLogin', {
        phone_e164: this.$store.state.signUpData.phone_number,
        site: 'highway.com',
        requested_carrier_id: this.$store.state.carriers.carrierDetails.id,
      });
      this.goToVerificationView(res);
    },
    async handleSubmit() {
      if (this.$store.state.signUpData.manualCarrier) {
        this.handleManualCarrierLogin();
      } else {
        this.handleLogin();
      }
    },
    async handleIDVEmailSubmit() {
      const isIDVEmail = this.email_address_verification?.length > 0;
      const email = isIDVEmail
        ? this.email_address_verification
        : this.$store.state.signUpData.email_address;

      const action = isIDVEmail
        ? 'users/updateEmail'
        : 'users/postSignUpOrLogin';
      const payload = isIDVEmail
        ? email
        : {
            email_address: this.$store.state.signUpData.email_address,
            site: 'highway.com',
            requested_carrier_id: this.$store.state.carriers.carrierDetails.id,
          };

      const res = await this.$store.dispatch(action, payload);

      if ([200, 201].includes(res.status)) {
        isIDVEmail
          ? this.goToPendingReviewEmail()
          : this.goToVerificationView(res);
      } else if (res.status == 409) {
        window.location.href = `/identity/saml/init?email=${this.$store.state.signUpData.email_address}&redirect_url=${process.env.API_URL}${process.env.BASE_URL}`;
        return;
      } else {
        this.isLoading = false;
        toastResponse(this, res, null);
      }
    },
    async handleEmailSubmit() {
      this.isLoading = true;
      this.checkEmailAddress();
      if (this.email_address_error) return;
      if (this.isIDVOnboardingFlowActive) {
        this.handleIDVEmailSubmit();
        return;
      }
      const res = await this.$store.dispatch('users/postSignUpOrLogin', {
        email_address: this.$store.state.signUpData.email_address,
        site: 'highway.com',
        requested_carrier_id: this.$store.state.carriers.carrierDetails.id,
      });

      this.goToVerificationView(res);
    },
    goToPendingReviewEmail() {
      this.$router.push({
        name: 'EmailVerificationPending',
      });
    },
    goToVerificationView(res) {
      if ([200, 201].includes(res.status)) {
        // email address or phone number signup success
        // send user to next step and wait for verification code
        if (
          res.data?.message?.[0] ==
          'Please submit a TOTP code from your authenticator app.'
        ) {
          return this.$router.push({ name: 'SecurityVerification' });
        }
        this.$router.push({
          name: 'SignUpOrLoginVerification',
          params: { canMoveOn: true, toVerification: true },
        });
      } else if (res.status == 409) {
        window.location.href = `/identity/saml/init?email=${this.$store.state.signUpData.email_address}&redirect_url=${process.env.API_URL}${process.env.BASE_URL}`;
      } else if (res.status === 422) {
        toastResponse(this, res, null);
      } else {
        toastResponse(this, res, null);
      }
      this.isLoading = false;
    },
    handleUserAlreadyLoggedIn: function () {
      const companyType =
        this.$store.state.users.currentUser.company.company_type;
      switch (companyType) {
        case 'broker':
          return this.$router.push({ name: 'Broker Dashboard' });
        case 'carrier':
          return this.$router.push({ name: 'CarrierWelcomePage' });
        case 'dispatcher':
          return this.$router.push({ name: 'Dispatcher Dashboard' });
        default:
          return this.$router.push({ name: 'Home' });
      }
    },
    handleManualLoginResponse: function (res) {
      switch (res.status) {
        case 200:
          this.$router.push({
            name: 'SignUpOrLoginVerification',
            params: { canMoveOn: true, toVerification: true },
            query: { needsClaimCarrier: 1 },
          });
          break;
        case 201:
          this.$router.push({
            name: 'SignUpOrLoginVerification',
            params: { canMoveOn: true, toVerification: true },
          });
          break;
        case 409:
          window.location.href = `/identity/saml/init?email=${this.email}&redirect_url=${process.env.API_URL}${process.env.BASE_URL}`;
          break;
        case 418:
          this.handleUserAlreadyLoggedIn();
          break;
        case 401:
        case 422:
        default:
          toastResponse(this, res, null);
          break;
      }
    },
  },
};
</script>

<style scoped>
.button {
  @apply my-3 mb-4 bg-light-gray !important;
}
</style>
